// extracted by mini-css-extract-plugin
export default {"removePhotoBtn":"style_removePhotoBtn__bdn1Z","photoPreview":"style_photoPreview__S3UQC","timezoneNote":"style_timezoneNote__8pN8O","infoIcon":"style_infoIcon__lBH2i"};